const HorizontalSpacer = ({ amount }) => (
  <div className={`h-${amount}`}>&nbsp;</div>
);

export default HorizontalSpacer;
